/* 08 LEFT - CUSTOM RUNWAY MUG BUILDER
   Used by sections/mug-08l.liquid (template product.08l-mug).
   The shopper picks an airport, a mug and a line color; the runway diagram is
   drawn live on a blank Printful mug photo and the choices ride to the order
   as line-item properties.

   DATA
     window.__OL_RUNWAYS__      assets/runways-08l.js  (IATA -> { i: ICAO, d: path })
                                Curated Route 08 geometry. Never regenerate or edit it.
     window.__OL_MUG_AIRPORTS__ assets/mug-airports-08l.js  ([IATA, name], best seller order)
     [data-olm-config]          JSON written by the section: variant ids + photo urls
                                (+ `scenes`, mug id -> a blank lifestyle photo of that mug, drawn live
                                like the studio views and shown as the last thumbnail).

   GEOMETRY (measured from Printful calibration mockups, 2026-10-12)
     Everything is laid out in INCHES on the flat print, relative to the middle
     of one mug face. The preview bends that around the mug; OLMug.renderPrint
     draws the same layout flat, twice, into a Printful print file. One layout,
     two outputs, so the preview cannot drift from what gets printed.
     - Print files are 300 dpi: 2700 x 1140 (white + color inside), 2253 x 1084 (black).
     - The print is centered opposite the handle. Each face (handle left / handle
       right) is centered 749 print px either side of the middle.
     - The black mug's print area is narrower, so a face-centered design has to be
       smaller there (2.3 in instead of 2.9 in) or it runs off the print.
     - In the 1200 px photos 1 print px = 0.556 photo px across and 0.537 down, the
       mug radius is 265 px and the face is centered at y = 638.
     - The camera looks slightly down on the mug, so a level line on the print
       bows: it sits up to 52 px higher at the mug's edges than in the middle. */
(function () {
  'use strict';
  if (window.OLMug) return; // the cart loads this file on demand; never run the builder twice
  var VERSION = '2026-10-12.15';
  var SVG_NS = 'http://www.w3.org/2000/svg';

  var MUGS = [
    { id: 'white',             label: 'White',             a: '#ffffff', b: '#ffffff', ink: 'black',      cx: { right: 528, left: 686 } },
    { id: 'black',             label: 'Black',             a: '#121212', b: '#121212', ink: 'white',      cx: { right: 521, left: 685 } },
    { id: 'black-inside',      label: 'Black inside',      a: '#ffffff', b: '#050505', ink: 'black',      cx: { right: 528, left: 686 } },
    { id: 'blue-inside',       label: 'Blue inside',       a: '#ffffff', b: '#1e9fcd', ink: 'blue',       cx: { right: 528, left: 686 } },
    { id: 'dark-blue-inside',  label: 'Dark Blue inside',  a: '#ffffff', b: '#1b1b51', ink: 'dark-blue',  cx: { right: 528, left: 686 } },
    { id: 'red-inside',        label: 'Red inside',        a: '#ffffff', b: '#e32a2d', ink: 'red',        cx: { right: 528, left: 686 } },
    { id: 'pink-inside',       label: 'Pink inside',       a: '#ffffff', b: '#f6a1b1', ink: 'pink',       cx: { right: 528, left: 686 } },
    { id: 'dark-green-inside', label: 'Dark Green inside', a: '#ffffff', b: '#226653', ink: 'dark-green', cx: { right: 528, left: 686 } }
  ];
  var INKS = [
    { id: 'black',      label: 'Black',      hex: '#12120f' },
    { id: 'white',      label: 'White',      hex: '#ffffff' },
    { id: 'blue',       label: 'Blue',       hex: '#1e9fcd' },
    { id: 'dark-blue',  label: 'Dark Blue',  hex: '#1b1b51' },
    { id: 'red',        label: 'Red',        hex: '#e32a2d' },
    { id: 'pink',       label: 'Pink',       hex: '#f6a1b1' },
    { id: 'dark-green', label: 'Dark Green', hex: '#226653' }
  ];
  var TYPES = [
    { id: 'none', label: 'None' },
    { id: 'iata', label: 'Code' },
    { id: 'icao', label: 'ICAO' },
    { id: 'name', label: 'Name' }
  ];

  // Layout, in inches unless noted.
  var ART_IN = { 'default': 2.9, black: 2.3 };
  var NAME_ONE_LINE_MAX = { 'default': 48, black: 33 }; // characters that fit on one line at 8 pt
  var LINE_WEIGHT = 0.024;      // stroke as a share of the artwork's width
  var TYPE_IN = 8 / 72;         // 8 pt
  var TYPE_GAP_IN = 0.1;
  var TYPE_LEAD = 1.35;
  var CODE_TRACK = 0.2;         // em
  var TYPE_FAMILY = 'OratorStd, ui-monospace, Menlo, monospace';
  var fontAdvance = 0.6;        // em; Orator is monospaced. Replaced by the measured value.

  // Print files.
  var DPI = 300;
  var PRINT = { 'default': { w: 2700, h: 1140 }, black: { w: 2253, h: 1084 } };
  var FACE_OFFSET_PX = 749;

  // Photo preview.
  var PHOTO_PPI = DPI * (200 / 360);
  var PHOTO_R = 265;
  var PHOTO_CY = 638;
  var PHOTO_V = 0.537 / 0.556;  // vertical scale relative to horizontal
  var PHOTO_BOW = 52;           // px a level line rises at the mug's edge
  var VIEWS = [{ id: 'right', label: 'Handle on the right' }, { id: 'left', label: 'Handle on the left' }];

  function kind(mugId) { return mugId === 'black' ? 'black' : 'default'; }
  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }
  // An ink that matches the outside of the mug would print invisibly.
  function inkAllowed(inkId, mugId) { return mugId === 'black' ? inkId !== 'black' : inkId !== 'white'; }

  function parsePath(d) {
    var segs = [];
    String(d).split('M').forEach(function (part) {
      var pts = part.split('L').map(function (p) { return p.trim().split(/[ ,]+/).map(Number); })
        .filter(function (p) { return p.length === 2 && !isNaN(p[0]) && !isNaN(p[1]); });
      if (pts.length > 1) segs.push(pts);
    });
    return segs;
  }

  function typeLines(airport, type, mugId) {
    if (type === 'iata') return [airport.iata];
    if (type === 'icao') return [airport.icao];
    if (type !== 'name') return [];
    return wrap(airport.name.toUpperCase(), NAME_ONE_LINE_MAX[kind(mugId)]);
  }

  // One line when it fits. Otherwise the fewest lines that keep every line inside
  // the print area, with the words spread evenly so no line is left with one word.
  function wrap(text, max) {
    if (text.length <= max) return [text];
    var words = text.split(' ');
    for (var n = Math.ceil(text.length / max); n <= words.length; n++) {
      for (var width = Math.ceil(text.length / n); width <= max; width++) {
        var lines = [], line = '';
        for (var i = 0; i < words.length; i++) {
          var next = line ? line + ' ' + words[i] : words[i];
          if (line && next.length > width) { lines.push(line); line = words[i]; } else line = next;
        }
        lines.push(line);
        if (lines.length <= n && lines.every(function (l) { return l.length <= max; })) return lines;
      }
    }
    return words;
  }

  /* The one layout both outputs draw from. Inches, origin = middle of a mug face, y down.
     -> { runways: [[[x,y],[x,y]...]], stroke, lines: [{ chars, xs, y }], size } */
  function layout(airport, mugId, type) {
    var art = ART_IN[kind(mugId)];
    var lines = typeLines(airport, type, mugId);
    var lead = TYPE_IN * TYPE_LEAD;
    var block = art + (lines.length ? TYPE_GAP_IN + lines.length * lead : 0);
    var top = -block / 2;
    var runways = parsePath(airport.d).map(function (pts) {
      return pts.map(function (p) { return [(p[0] - 50) / 100 * art, top + p[1] / 100 * art]; });
    });
    var step = (fontAdvance + (type === 'name' ? 0 : CODE_TRACK)) * TYPE_IN;
    return {
      runways: runways,
      stroke: LINE_WEIGHT * art,
      size: TYPE_IN,
      lines: lines.map(function (line, i) {
        var chars = Array.from(line);
        return {
          chars: chars,
          xs: chars.map(function (_, n) { return (n - (chars.length - 1) / 2) * step; }),
          y: top + art + TYPE_GAP_IN + TYPE_IN * 0.8 + i * lead
        };
      })
    };
  }

  /* Draw a ready-to-upload Printful print file into `canvas`: the design on both
     faces, transparent background. spec = { airport, mug, ink, type }. */
  function renderPrint(spec, canvas) {
    var p = PRINT[kind(spec.mug)], L = layout(spec.airport, spec.mug, spec.type);
    var ink = byId(INKS, spec.ink).hex;
    canvas.width = p.w; canvas.height = p.h;
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, p.w, p.h);
    ctx.strokeStyle = ink; ctx.fillStyle = ink;
    ctx.lineCap = 'round'; ctx.lineWidth = L.stroke * DPI;
    ctx.font = (L.size * DPI) + 'px ' + TYPE_FAMILY;
    ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
    [-1, 1].forEach(function (side) {
      var cx = p.w / 2 + side * FACE_OFFSET_PX, cy = p.h / 2;
      L.runways.forEach(function (pts) {
        ctx.beginPath();
        pts.forEach(function (pt, i) { ctx[i ? 'lineTo' : 'moveTo'](cx + pt[0] * DPI, cy + pt[1] * DPI); });
        ctx.stroke();
      });
      L.lines.forEach(function (line) {
        line.chars.forEach(function (ch, i) { ctx.fillText(ch, cx + line.xs[i] * DPI, cy + line.y * DPI); });
      });
    });
    return canvas;
  }

  function measureFont(done) {
    if (!(document.fonts && document.fonts.load)) return done();
    document.fonts.load('100px OratorStd').then(function () {
      var ctx = document.createElement('canvas').getContext('2d');
      ctx.font = '100px OratorStd';
      var w = ctx.measureText('M').width;
      if (w > 0) fontAdvance = w / 100;
      done();
    }, done);
  }

  function airports() {
    var rw = window.__OL_RUNWAYS__ || {}, list = window.__OL_MUG_AIRPORTS__ || [];
    return list.filter(function (row) { return rw[row[0]]; }).map(function (row) {
      var r = rw[row[0]];
      return { iata: row[0], icao: r.i, name: row[1], d: r.d, n: parsePath(r.d).length,
        hay: (row[0] + ' ' + r.i + ' ' + row[1]).toLowerCase() };
    });
  }

  // Flat print inches -> photo pixels, wrapped around one mug as the camera sees it:
  // squeezed toward the edges, bowed away from the middle, then tilted with the mug.
  function project(xIn, yIn, pl) {
    var t = xIn * PHOTO_PPI / PHOTO_R, r = pl.rot * Math.PI / 180;
    var u = pl.k * PHOTO_R * Math.sin(t);
    var v = pl.k * (pl.kv || 1) * yIn * PHOTO_PPI * PHOTO_V - pl.bow * (1 - Math.cos(t));
    return {
      x: pl.cx + u * Math.cos(r) - v * Math.sin(r),
      y: pl.cy + u * Math.sin(r) + v * Math.cos(r),
      // how far a glyph has to turn to sit on the line, in degrees
      tilt: pl.rot + Math.atan(-pl.bow * Math.tan(t) / (pl.k * PHOTO_R)) * 180 / Math.PI
    };
  }

  // Draw one laid-out design onto each mug face in a picture. nodes = { art: <path>, type: <text> }.
  function paint(nodes, L, places, ink) {
    var d = '', k = 0;
    nodes.type.textContent = '';
    nodes.type.setAttribute('fill', ink);
    // assets/custom.css forces proxima-nova on every element with !important, so a
    // plain attribute loses and the type would preview in the wrong face.
    nodes.type.style.setProperty('font-family', TYPE_FAMILY, 'important');
    places.forEach(function (pl) {
      k += pl.k / places.length;
      L.runways.forEach(function (pts) {
        for (var i = 1; i < pts.length; i++) {
          for (var s = (i === 1 ? 0 : 1); s <= 16; s++) {
            var f = s / 16;
            var q = project(pts[i - 1][0] + (pts[i][0] - pts[i - 1][0]) * f, pts[i - 1][1] + (pts[i][1] - pts[i - 1][1]) * f, pl);
            d += (i === 1 && s === 0 ? 'M' : 'L') + q.x.toFixed(1) + ' ' + q.y.toFixed(1);
          }
        }
      });
      L.lines.forEach(function (line) {
        var pts = line.xs.map(function (x) { return project(x, line.y, pl); });
        var ts = document.createElementNS(SVG_NS, 'tspan');
        ts.setAttribute('x', pts.map(function (q) { return q.x.toFixed(1); }).join(' '));
        ts.setAttribute('y', pts.map(function (q) { return q.y.toFixed(1); }).join(' '));
        ts.setAttribute('rotate', pts.map(function (q) { return q.tilt.toFixed(1); }).join(' '));
        ts.setAttribute('font-size', L.size * PHOTO_PPI * pl.k);
        ts.style.setProperty('font-family', TYPE_FAMILY, 'important'); // the global rule hits each tspan too
        ts.textContent = line.chars.join('');
        nodes.type.appendChild(ts);
      });
    });
    nodes.art.setAttribute('d', d);
    nodes.art.setAttribute('stroke', ink);
    nodes.art.setAttribute('stroke-width', L.stroke * PHOTO_PPI * k);
  }

  // The svg parts of one mug picture: the photo with the print group on top.
  function mugNodes() {
    var n = { svg: document.createElementNS(SVG_NS, 'svg'), photo: document.createElementNS(SVG_NS, 'image'),
      print: document.createElementNS(SVG_NS, 'g'), art: document.createElementNS(SVG_NS, 'path'), type: document.createElementNS(SVG_NS, 'text') };
    n.art.setAttribute('fill', 'none'); n.art.setAttribute('stroke-linecap', 'round'); n.art.setAttribute('stroke-linejoin', 'round');
    n.type.setAttribute('text-anchor', 'middle');
    n.print.appendChild(n.art); n.print.appendChild(n.type);
    n.svg.appendChild(n.photo); n.svg.appendChild(n.print);
    return n;
  }

  /* A small picture of one ordered mug, for the cart. `code` is the line item's `_mug` property
     (IATA|mug|ink|type) and `photoUrl` its `_art_image` (the blank mug, handle on the right).
     Returns an <svg>, or null when the code does not describe a mug we can draw. */
  var cartAirports = null;
  function cartThumb(code, photoUrl) {
    var p = String(code || '').split('|');
    if (p.length !== 4) return null;
    if (!cartAirports) { cartAirports = {}; airports().forEach(function (a) { cartAirports[a.iata] = a; }); }
    var airport = cartAirports[p[0]], mug = byId(MUGS, p[1]), ink = byId(INKS, p[2]), type = byId(TYPES, p[3]);
    if (!airport || !mug || !ink || !type || !photoUrl) return null;
    var n = mugNodes();
    n.svg.setAttribute('viewBox', '150 150 900 900');
    n.photo.setAttribute('width', 1200); n.photo.setAttribute('height', 1200); n.photo.setAttribute('href', photoUrl);
    n.print.style.mixBlendMode = mug.id === 'black' ? 'normal' : 'multiply';
    paint(n, layout(airport, mug.id, type.id), [{ cx: mug.cx.right, cy: PHOTO_CY, k: 1, rot: 0, bow: PHOTO_BOW }], ink.hex);
    return n.svg;
  }

  window.OLMug = { VERSION: VERSION, MUGS: MUGS, INKS: INKS, TYPES: TYPES, PRINT: PRINT,
    airports: airports, layout: layout, renderPrint: renderPrint, measureFont: measureFont, inkAllowed: inkAllowed,
    cartThumb: cartThumb };

  /* ------------------------------------------------------------------ builder */
  var root = document.querySelector('[data-olm]');
  if (!root) return;
  var AIRPORTS = airports();
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-olm-config]').textContent); } catch (e) {}
  var variants = cfg.variants || {}, photos = cfg.photos || {};
  /* Blank lifestyle photos from Printful, 1400 px, one scene per kind of mug (Printful shoots different
     scenes for different mugs, and only the plain white mug has the two-mug one). The design is drawn on.
     Where each mug face sits, its tilt and its size were measured from Printful calibration renders of the
     same scene: k = size relative to the studio photos, kv = extra vertical squash from a steeper camera,
     rot = degrees clockwise, bow = px a level line rises at the mug's edge (negative: the camera is
     slightly below that mug). */
  var SCENE_KINDS = {
    clink: { label: 'Two mugs', what: 'Two white mugs, each held by a hand, clinking together', thumbBox: '250 300 900 900', places: [
      { cx: 571, cy: 670, k: 0.486, rot: 19, bow: 0 },
      { cx: 848, cy: 772, k: 0.497, rot: -1, bow: -15 }] },
    hands: { label: 'In hand', what: 'The mug held in two hands, handle on the left', thumbBox: '300 264 900 900', places: [
      { cx: 748, cy: 714, k: 1.04, kv: 0.965, rot: -1.6, bow: 37 }] },
    shelf: { label: 'On a shelf', what: 'The mug on a wooden board, handle on the left', thumbBox: '313 229 900 900', places: [
      { cx: 763, cy: 679, k: 0.986, kv: 0.958, rot: -1.2, bow: 48 }] }
  };
  var sceneUrls = cfg.scenes || {};
  function sceneFor(mugId) {
    var url = sceneUrls[mugId];
    if (!url) return null;
    var kind = SCENE_KINDS[mugId === 'white' ? 'clink' : mugId === 'black' ? 'shelf' : 'hands'];
    return { url: url, size: 1400, label: kind.label, what: kind.what, thumbBox: kind.thumbBox, places: kind.places };
  }
  var MAX_ROWS = 60;

  function $(name) { return root.querySelector('[data-olm-' + name + ']'); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  if (!AIRPORTS.length) {
    $('results').appendChild(el('li', 'olm__empty', 'The airport list did not load. Please refresh the page.'));
    return;
  }

  // Only offer mugs the product actually has a variant for.
  var mugs = MUGS.filter(function (m) { return variants[m.id]; });
  if (!mugs.length) mugs = MUGS;
  var state = { airport: AIRPORTS[0], mug: mugs[0], ink: byId(INKS, mugs[0].ink), inkPicked: false, type: 'iata', qty: 1, view: 'right' };

  function thumb(a) {
    var s = document.createElementNS(SVG_NS, 'svg');
    s.setAttribute('viewBox', '0 0 100 100');
    s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(SVG_NS, 'path');
    p.setAttribute('d', a.d); p.setAttribute('fill', 'none'); p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '4'); p.setAttribute('stroke-linecap', 'round');
    s.appendChild(p);
    return s;
  }

  function search(q) {
    q = q.trim().toLowerCase();
    // Nothing typed: list only the airport that is on the mug right now, so the choice is always visible.
    if (!q) return [state.airport];
    var words = q.split(/\s+/);
    var hits = AIRPORTS.filter(function (a) { return words.every(function (w) { return a.hay.indexOf(w) !== -1; }); });
    // Exact code first, then codes that start with the query, then best seller order.
    function rank(a) {
      var i = a.iata.toLowerCase(), c = a.icao.toLowerCase();
      if (i === q || c === q) return 0;
      if (i.indexOf(q) === 0 || c.indexOf(q) === 0) return 1;
      return 2;
    }
    return hits.map(function (a, n) { return [rank(a), n, a]; })
      .sort(function (x, y) { return x[0] - y[0] || x[1] - y[1]; }).map(function (t) { return t[2]; });
  }

  function renderResults() {
    var q = $('search').value, hits = search(q), list = $('results');
    list.textContent = '';
    $('count').textContent = hits.length > MAX_ROWS ? 'Keep typing to narrow it down.' : '';
    if (!hits.length) {
      list.appendChild(el('li', 'olm__empty', "Sorry we don't carry this one."));
      return;
    }
    hits.slice(0, MAX_ROWS).forEach(function (a) {
      var li = el('li'), b = el('button', 'olm__row' + (a === state.airport ? ' is-sel' : ''));
      b.type = 'button';
      b.setAttribute('aria-pressed', String(a === state.airport));
      b.appendChild(thumb(a));
      b.appendChild(el('span', 'olm__row-code', a.iata));
      b.appendChild(el('span', 'olm__row-name', a.name));
      b.appendChild(el('span', 'olm__row-n', a.n + (a.n === 1 ? ' runway' : ' runways')));
      b.addEventListener('click', function () { state.airport = a; render(); });
      li.appendChild(b);
      list.appendChild(li);
    });
  }

  function renderSwatches() {
    var box = $('mugs');
    box.textContent = '';
    mugs.forEach(function (m) {
      var v = variants[m.id], soldOut = v && v.available === false;
      var b = el('button', 'olm__sw' + (m.a !== m.b ? ' olm__sw--split' : '') + (m === state.mug ? ' is-sel' : ''));
      b.type = 'button';
      b.title = soldOut ? m.label + ' is sold out' : m.label;
      b.setAttribute('aria-label', m.label + ' mug' + (soldOut ? ', sold out' : ''));
      b.setAttribute('aria-pressed', String(m === state.mug));
      b.disabled = soldOut;
      b.style.setProperty('--a', m.a); b.style.setProperty('--b', m.b);
      b.addEventListener('click', function () {
        state.mug = m;
        if (!state.inkPicked || !inkAllowed(state.ink.id, m.id)) { state.ink = byId(INKS, m.ink); state.inkPicked = false; }
        render();
      });
      box.appendChild(b);
    });
    box = $('inks');
    box.textContent = '';
    INKS.forEach(function (i) {
      var ok = inkAllowed(i.id, state.mug.id);
      var b = el('button', 'olm__sw' + (i === state.ink ? ' is-sel' : ''));
      b.type = 'button';
      b.title = ok ? i.label : i.label + ' would not show on this mug';
      b.setAttribute('aria-label', i.label + ' lines');
      b.setAttribute('aria-pressed', String(i === state.ink));
      b.disabled = !ok;
      b.style.setProperty('--a', i.hex);
      b.addEventListener('click', function () { state.ink = i; state.inkPicked = true; render(); });
      box.appendChild(b);
    });
    $('mug-pick').textContent = state.mug.label;
    $('ink-pick').textContent = state.ink.label;
  }

  function renderTypes() {
    var box = $('types');
    box.textContent = '';
    TYPES.forEach(function (t) {
      var b = el('button', 'olp__pill' + (t.id === state.type ? ' is-sel' : ''), t.label);
      b.type = 'button';
      b.setAttribute('aria-pressed', String(t.id === state.type));
      b.addEventListener('click', function () { state.type = t.id; render(); });
      box.appendChild(b);
    });
  }

  // What one view shows: the photo and where each mug face is in it.
  function picture(viewId) {
    var m = state.mug;
    var sc = viewId === 'scene' && sceneFor(m.id);
    if (sc) return { url: sc.url, size: sc.size, box: '0 0 ' + sc.size + ' ' + sc.size, thumbBox: sc.thumbBox, places: sc.places, blend: m.id === 'black' ? 'normal' : 'multiply' };
    return { url: photoUrl(m.id, viewId), size: 1200, box: '0 0 1200 1200', thumbBox: '150 150 900 900',
      places: [{ cx: m.cx[viewId], cy: PHOTO_CY, k: 1, rot: 0, bow: PHOTO_BOW }],
      // Ink sinks into the photo's shading on a white mug; on the black mug it sits on top.
      blend: m.id === 'black' ? 'normal' : 'multiply' };
  }
  function photoUrl(mugId, view) { var p = photos[mugId]; return p && (p[view] || p.right); }

  // Draw the current design into one mug picture (the main image or a thumbnail).
  function drawMug(nodes, viewId, isThumb) {
    var pic = picture(viewId);
    nodes.svg.setAttribute('viewBox', isThumb ? pic.thumbBox : pic.box);
    nodes.photo.setAttribute('width', pic.size); nodes.photo.setAttribute('height', pic.size);
    if (pic.url && nodes.photo.getAttribute('href') !== pic.url) nodes.photo.setAttribute('href', pic.url);
    nodes.print.style.mixBlendMode = pic.blend;
    paint(nodes, layout(state.airport, state.mug.id, state.type), pic.places, state.ink.hex);
  }

  var mainNodes = { svg: $('photo').ownerSVGElement, photo: $('photo'), print: $('print'), art: $('art'), type: $('type') };
  var thumbs = VIEWS.concat([{ id: 'scene', label: 'In use' }]).map(function (v) {
    var b = el('button', 'olp__thumb olm__thumb');
    b.type = 'button';
    b.setAttribute('aria-label', v.label);
    b.title = v.label;
    var nodes = mugNodes();
    nodes.svg.setAttribute('aria-hidden', 'true');
    b.appendChild(nodes.svg);
    b.addEventListener('click', function () { state.view = v.id; renderMug(); });
    $('thumbs').appendChild(b);
    return { view: v, button: b, nodes: nodes };
  });

  function renderMug() {
    var a = state.airport, m = state.mug, sc = sceneFor(m.id);
    // Not every mug has a lifestyle photo; fall back to the studio view when this one does not.
    if (state.view === 'scene' && !sc) state.view = 'right';
    drawMug(mainNodes, state.view, false);
    thumbs.forEach(function (t) {
      var isScene = t.view.id === 'scene';
      t.button.hidden = isScene && !sc;
      if (isScene && sc) { t.button.title = sc.label; t.button.setAttribute('aria-label', sc.label); }
      if (!t.button.hidden) drawMug(t.nodes, t.view.id, true);
      t.button.classList.toggle('is-sel', t.view.id === state.view);
      t.button.setAttribute('aria-pressed', String(t.view.id === state.view));
    });
    var design = a.iata + ' runway diagram in ' + state.ink.label.toLowerCase();
    $('alt').textContent = state.view === 'scene'
      ? sc.what + '. ' + m.label + ' mug with the ' + design
      : m.label + ' mug with the ' + design + ', ' + (state.view === 'left' ? 'handle on the left' : 'handle on the right');
  }

  function typeProperty() {
    var a = state.airport;
    return { none: 'None', iata: 'Code (' + a.iata + ')', icao: 'ICAO code (' + a.icao + ')', name: 'Airport name' }[state.type];
  }

  function renderText() {
    var a = state.airport, v = variants[state.mug.id];
    $('code').textContent = a.iata;
    $('name').textContent = a.name;
    $('summary').textContent = a.iata + ', ' + a.name + '. ' + state.mug.label + ' mug, ' +
      state.ink.label.toLowerCase() + ' lines, small type: ' +
      { none: 'none', iata: 'code ' + a.iata, icao: 'ICAO code ' + a.icao, name: 'airport name' }[state.type] + '. Printed on both sides.';
    var add = $('add');
    if (!v) { add.disabled = true; $('add-label').textContent = 'Unavailable'; }
    else if (v.available === false) { add.disabled = true; $('add-label').textContent = 'Sold out'; }
    else { add.disabled = false; $('add-label').textContent = 'Add to cart'; }
  }

  function render() { renderResults(); renderSwatches(); renderTypes(); renderMug(); renderText(); }

  /* ------------------------------------------------------------------ cart
     Same refresh as sections/08l-product.liquid: Horizon 4.1.3 only repaints the
     cart icon and opens the drawer on 'shopify:cart:lines-update'. */
  function cartSectionIds() {
    var ids = {};
    document.querySelectorAll('cart-items-component, cart-drawer-component, cart-icon').forEach(function (n) {
      var sid = n.getAttribute('data-section-id');
      if (!sid) { var h = n.closest('[data-section-id]'); sid = h && h.getAttribute('data-section-id'); }
      if (sid) ids[sid] = 1;
    });
    return Object.keys(ids);
  }
  function refreshCart(res) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      try {
        var ev = new Event('shopify:cart:lines-update', { bubbles: true });
        ev.action = 'add';
        ev.promise = Promise.resolve({
          cart: { totalQuantity: cart.item_count },
          detail: { itemCount: cart.item_count, source: 'olm', sections: (res && res.sections) || {} }
        });
        document.dispatchEvent(ev);
      } catch (e) {}
    }).catch(function () {});
  }
  function cartError(body) {
    var m = body && (body.description || body.message);
    return typeof m === 'string' && m ? m : '';
  }

  function addToCart() {
    var v = variants[state.mug.id], a = state.airport, msg = $('msg'), add = $('add'), label = $('add-label');
    if (!v || v.available === false) return;
    add.disabled = true; label.textContent = 'Adding...'; msg.className = 'olp__msg'; msg.textContent = '';
    var item = { id: v.id, quantity: state.qty, properties: {
      'Airport': a.iata + ', ' + a.name,
      'Line color': state.ink.label,
      'Small type': typeProperty(),
      // Hidden from the shopper (leading underscore). The studio's print file tool reads it.
      '_mug': [a.iata, state.mug.id, state.ink.id, state.type].join('|')
    } };
    // Link to this order's print file (sections/mug-print-08l.liquid). Shows on the order in Shopify admin,
    // so the studio can open it and download the file to send to Printful.
    if (cfg.printUrl) item.properties._print = cfg.printUrl + [a.iata, state.mug.id, state.ink.id, state.type].join('.');
    // snippets/cart-products.liquid shows `_art_image` as the cart thumbnail: the mug in the chosen color.
    if (photoUrl(state.mug.id, 'right')) item.properties._art_image = photoUrl(state.mug.id, 'right');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item], sections: cartSectionIds().join(','), sections_url: location.pathname }) })
      .then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return null; }).then(function (body) {
            var err = new Error('add'); err.shopifyMsg = cartError(body); throw err;
          });
        }
        return r.json();
      })
      .then(function (res) {
        refreshCart(res);
        msg.className = 'olp__msg ok'; msg.textContent = 'Added to cart ✓';
        renderText();
      })
      .catch(function (err) {
        msg.className = 'olp__msg';
        msg.textContent = err.shopifyMsg || 'That did not go through. Please check your connection and try again.';
        renderText();
      });
  }

  $('search').addEventListener('input', renderResults);
  $('add').addEventListener('click', addToCart);
  root.querySelectorAll('[data-olm-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.qty = Math.max(1, Math.min(99, state.qty + Number(b.getAttribute('data-olm-qty-step'))));
      $('qty').value = state.qty;
    });
  });
  $('qty').addEventListener('change', function () {
    state.qty = Math.max(1, Math.min(99, parseInt($('qty').value, 10) || 1));
    $('qty').value = state.qty;
  });

  // Warm the other mug photos so swapping colors is instant.
  mugs.forEach(function (m) { VIEWS.forEach(function (v) { var u = photoUrl(m.id, v.id); if (u) new Image().src = u; }); });
  render();
  measureFont(renderMug);
  try { console.log('[08L mug] ' + VERSION + ' - ' + AIRPORTS.length + ' airports'); } catch (e) {}
})();
